import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-yes-no-buttons',
  imports: [CommonModule, TranslocoPipe, Button],
  standalone: true,
  template: `
    <div class="flex justify-end gap-2">
      <p-button
        severity="secondary"
        size="small"
        (onClick)="onNoClick()"
        [label]="'global.no' | transloco"
        *ngIf="state() === false; else showNoButton" />
      <ng-template #showNoButton>
        <p-button severity="secondary" size="small" (onClick)="onNoClick()" [label]="'global.no' | transloco" />
      </ng-template>
      <p-button
        severity="secondary"
        size="small"
        (onClick)="onYesClick()"
        [label]="'global.yes' | transloco"
        *ngIf="state() === true; else showYesButton" />
      <ng-template #showYesButton>
        <p-button severity="secondary" size="small" (onClick)="onYesClick()" [label]="'global.yes' | transloco" />
      </ng-template>
    </div>
  `,
})
export class YesNoButtonsComponent {
  state = input<boolean | undefined>(undefined);
  @Output() onYes = new EventEmitter();
  @Output() onNo = new EventEmitter();

  onYesClick() {
    this.onYes.emit();
  }

  onNoClick() {
    this.onNo.emit();
  }
}
